import {http} from '@/http/index.js';

async function createGesture(girlId) {
  return http
    .post(`/girls/${girlId}/verification-gesture`)
    .then((response) => response.data.data);
}

export {createGesture};
